import(/* webpackMode: "eager", webpackExports: ["PrivacyPolicy"] */ "/vercel/path0/frontend_next/src/screens/user/PrivacyPolicy.tsx");
